import {useEntitlement} from '@github-ui/copilot-chat/components/quota/EntitlementContext'
import {CopilotLicenseType} from '@github-ui/copilot-chat/utils/copilot-chat-types'

import styles from '../ChatInputBanners.module.css'
import {SkuSuccessBanner} from '../SkuSuccessBanner/SkuSuccessBanner'
import {useSkuSuccessBanners} from '../SkuSuccessBanner/use-sku-success-banners'

export function NewConversationBanners() {
  const entitlement = useEntitlement()
  const licenseType = entitlement.licenseType
  const {activeSku, visibility} = useSkuSuccessBanners()

  // Question: What happens when not LicensedFull?
  const showTrialBanner = activeSku === 'trial' && licenseType === CopilotLicenseType.LicensedFull
  const showOtherSkuBanner = activeSku && activeSku !== 'trial'

  return (
    <>
      {showTrialBanner && visibility.trial && (
        <SkuSuccessBanner skuType={activeSku} className={styles.banner} onDismiss={visibility.trial.onDismiss} />
      )}

      {showOtherSkuBanner && visibility[activeSku] && (
        <SkuSuccessBanner skuType={activeSku} className={styles.banner} onDismiss={visibility[activeSku].onDismiss} />
      )}
    </>
  )
}
